export default __webpack_public_path__ + "_/sounds/incubator_bet-67d939d3e3a4a9d4ac5126971bcb69d7165d04f6a06ba311454efdda9ed56ddd.mp3";